<template>
  <div class="calculator__items">
    <div class="calculator__item calculator__item_active">
      <div class="calculator__item-content">
        <div class="accordion accordion_calc">
          <div class="accordion__items">
            <div
              v-for="(item, index) in items"
              :key="index"
            >
              <CalculatorFormCustomsItem
                class="calculator-form-customs__item"
                :index="index"
                :item="item"
                :numeric-code="orderCalcPIP.sender.country"
                :check-validate="checkValidate"
                :show-btn-delete="items && items.length > 1"
                @validate="onItemValidate"
                @delete="onDeleteItemByIndex"
                @export-cost="($event) => onExport($event, index)"
              />
            </div>
          </div>
        </div>
        <div class="calculator-form-customs">
          <div
            v-if="items.length < MAX_ITEMS"
          >
            <button
              class="calculator-form-customs__btn-add"
              type="button"
              @click="addItem"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7.5 22.5C8.32843 22.5 9 21.8284 9 21C9 20.1716 8.32843 19.5 7.5 19.5C6.67157 19.5 6 20.1716 6 21C6 21.8284 6.67157 22.5 7.5 22.5Z"
                  fill="#333333"
                />
                <path
                  d="M18 22.5C18.8284 22.5 19.5 21.8284 19.5 21C19.5 20.1716 18.8284 19.5 18 19.5C17.1716 19.5 16.5 20.1716 16.5 21C16.5 21.8284 17.1716 22.5 18 22.5Z"
                  fill="#50616F"
                />
                <path
                  d="M3.735 2.103C3.70103 1.93304 3.60924 1.7801 3.47525 1.67017C3.34125 1.56023 3.17332 1.5001 3 1.5H0V3H2.385L5.265 17.397C5.29897 17.567 5.39076 17.7199 5.52475 17.8298C5.65875 17.9398 5.82668 17.9999 6 18H19.5V16.5H6.615L6.015 13.5H19.5C19.6706 13.5 19.8361 13.4418 19.9692 13.335C20.1023 13.2282 20.195 13.0793 20.232 12.9127L21.933 5.25H20.3977L18.8985 12H5.715L3.735 2.103Z"
                  fill="#50616F"
                />
                <path
                  d="M13.5 4.5V1.5H12V4.5H9V6H12V9H13.5V6H16.5V4.5H13.5Z"
                  fill="#50616F"
                />
              </svg>
              Добавить вложение
            </button>
          </div>
          <div class="calculator__cols">
            <div class="calculator__col">
              <div class="calculator-form__fields">
                <div class="calculator-form__field calculator-form__field_input calculator-form__field_full-width">
                  <div class="calculator-field__label">
                    Стоимость вложений
                  </div>
                  <div class="d-flex">
                    <span
                      class="field-input me-2"
                      :class="{'field-item__error': totalItemsPriceError && totalItemsPrice !== '0', 'field-full': totalItemsPrice }"
                      style="flex-grow: 1"
                    >
                      <span class="label-description">Цена</span>
                      <input
                        ref="cost"
                        class="field-input__inner"
                        autocomplete="new-password"
                        :placeholder="placeholder"
                        :disabled="true"
                        type="text"
                        :required="true"
                        :max-length="8"
                        inputmode="decimal"
                        :value="totalItemsPrice === '0' ? '' : totalItemsPrice"
                      >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.25 3H7.5V11.25H5.25V12.75H7.5V15H5.25V16.5H7.5V21H9V16.5H15.75V15H9V12.75H14.25C15.443 12.7486 16.5868 12.2741 17.4304 11.4304C18.2741 10.5868 18.7486 9.44305 18.75 8.25V7.5C18.7486 6.30695 18.2741 5.16317 17.4304 4.31955C16.5868 3.47594 15.443 3.00139 14.25 3ZM17.25 8.25C17.249 9.04534 16.9326 9.80783 16.3702 10.3702C15.8078 10.9326 15.0453 11.249 14.25 11.25H9V4.5H14.25C15.0453 4.50099 15.8078 4.81738 16.3702 5.37978C16.9326 5.94217 17.249 6.70466 17.25 7.5V8.25Z"
                          fill="#50616F"
                        />
                      </svg>
                    </span>
                    <span
                      class="field-input"
                      :class="{'field-item__error': totalItemsPriceError && totalItemsExport !== '0', 'field-full': totalItemsExport }"
                      style="flex-grow: 1"
                    >
                      <span class="label-description">Цена</span>
                      <input
                        ref="cost"
                        class="field-input__inner"
                        autocomplete="new-password"
                        :placeholder="placeholder"
                        :disabled="true"
                        type="text"
                        :required="true"
                        :max-length="8"
                        inputmode="decimal"
                        :value="totalItemsExport === '0' ? '' : totalItemsExport"
                      >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12.75 19.5C10.038 19.5 8.00025 17.7773 7.1655 15H14.25V13.5H6.849C6.7832 13.0027 6.75013 12.5016 6.75 12C6.75 11.7525 6.7575 11.502 6.7695 11.25H14.25V9.75H6.92775C7.38375 7.014 8.8575 4.5 12.75 4.5C15.6397 4.5 16.899 5.73525 18.096 7.8675L19.404 7.1325C18.1987 4.98675 16.5585 3 12.75 3C7.98375 3 5.25 6.2805 5.25 12C5.25 17.2987 8.334 21 12.75 21C16.5585 21 18.1987 19.014 19.404 16.8675L18.096 16.1325C16.899 18.2655 15.6397 19.5 12.75 19.5Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </div>
                  <span
                    v-if="totalItemsPriceError && totalItemsPrice !== '0'"
                    class="field__error_inv"
                  >
                    Стоимость вложений должна быть больше 500 рублей и не превышать 1000 евро по текущему курсу.
                  </span>
                  <div class="field__notice">
                    Стоимость вложений не должна превышать 1000 евро по текущему курсу.
                  </div>
                </div>
              </div>
            </div>
            <div class="calculator__col" />
          </div>
        </div>
      </div>
      <div class="calculator-nav">
        <span
          v-if="validations && validations.$error"
          class="check-point-error calc-hide-desktop"
        >Пожалуйста, заполните все отмеченные поля</span>
        <span
          v-else-if="!items.length"
          class="check-point-error calc-hide-desktop"
        >Необходимо добавить вложение</span>
      </div>
    </div>
    <CalcNavDesktop
      v-if="!isMobile"
      :is-loading="isLoading"
      :error-text="navErrorText"
      @stepValidation="customsStepValidation"
      @step-back="$emit('step-back')"
    >
      <template #btnNext>
        Оформить
      </template>
    </CalcNavDesktop>
    <CalcNavMobile
      v-else
      :is-loading="isLoading"
      :error-text="navErrorText"
      @stepValidation="customsStepValidation"
      @step-back="$emit('step-back')"
    >
      <template #btnNext>
        Оформить
      </template>
    </CalcNavMobile>
  </div>
</template>

<script>
import CalcNavDesktop from '../components/CalcNavDesktop.vue';
import CalcNavMobile from '../components/CalcNavMobile.vue';
import deviceInfo from '../../../helpers/device';
import CalculatorFormCustomsItem from './CalculatorFormCustomsItem.vue';

const MAX_ITEMS = 10;

export default {
  name: 'CalculatorFormCustomsView',
  components: {
    CalcNavMobile, CalcNavDesktop, CalculatorFormCustomsItem,
  },
  props: ['orderPIP', 'orderCalcPIP', 'validations', 'errorDictionary', 'isCustoms', 'items', 'calcImport', 'receiverPayImport'],

  data: () => ({
    isLoading: false,
    revert: '1',
    itemDefault: {
      descrExp: '',
      descrImp: '',
      manufacturer: '',
      quantity: '',
      price: '',
      priceExport: '',
      linkWeb: '',
    },
    MAX_ITEMS,
    checkValidate: false,
    isFormValid: true,
  }),
  computed: {
    ...deviceInfo,
    totalItemsPrice() {
      const price = this.items.reduce((acc, current) => acc + current.price.replace(/\s/g, '') * current.quantity, 0) || '';
      return new Intl.NumberFormat('ru-RU').format(price).replaceAll(',', '.');
    },
    totalItemsExport() {
      const price = this.items.reduce((acc, current) => acc + +current.priceExport.replace(/\s/g, ''), 0) || '';
      return new Intl.NumberFormat('ru-RU').format(price).replace(',', '.');
    },
    totalItemsPriceError() {
      return +(this.totalItemsExport.replace(/\s/g, '')) > 1000 || +(this.totalItemsPrice.replace(/\s/g, '')) < 500;
    },
    navErrorText() {
      if (!this.isFormValid || this.totalItemsPriceError) return 'Пожалуйста, заполните все отмеченные поля';
      if (!this.items.length) return 'Необходимо добавить вложение';
      return '';
    },
  },
  watch: {
    totalItemsPrice(val) {
      if (val) {
        this.orderPIP.public_price = val.replace(/\s/g, '') * 100;
      }
    },
    items: {
      handler() {
        if (!this.isFormValid) {
          this.isFormValid = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    onDeleteItemByIndex(index) {
      const items = [...this.items];
      items.splice(index, 1);
      this.$emit('changeItems', items);
    },
    addItem() {
      const items = [...this.items];
      items.push({ ...this.itemDefault });
      this.$emit('changeItems', items);
    },
    async customsStepValidation() {
      this.checkValidate = true;
      await this.$nextTick();

      if (this.isFormValid && !this.totalItemsPriceError && this.items.length) {
        this.customsStepHandler();
      }
      this.checkValidate = false;
    },
    customsStepHandler() {
      this.$emit('step-up');
    },
    onItemValidate(validate) {
      if (!validate) this.isFormValid = false;
    },
    onExport($event, index) {
      this.items[index].priceExport = $event;
    },
  },
};
</script>

<style lang="scss" scoped>
.calc-customs-item__row {
  display: flex;
  width: 100%;
  margin-right: -24px;
  margin-left: -24px;
  margin-bottom: 40px;
  @media (max-width: 1051px) {
    flex-direction: column;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 20px !important;
  }
}
.calc-customs-item__col {
  padding-left: 24px;
  padding-right: 24px;
  &:nth-of-type(n) {
    align-self: center;
    width: 410px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #979797;
  }
  @media (max-width: 1200px) {
    &:nth-of-type(n) {
      width: 320px;
    }
  }
  &:nth-of-type(2n + 1) {
    align-self: flex-start;
    width: 689px;
  }
  @media (max-width: 1200px) {
    &:nth-of-type(2n + 1) {
      width: 500px;
    }
  }
  @media (max-width: 1051px) {
    &:nth-of-type(n),
    &:nth-of-type(2n + 1) {
      width: 100%;
      padding-left: 0;
      padding-right: 0;
    }
    &:nth-of-type(2n + 1) {
      margin-bottom: 4px;
    }
  }
}
.calculator-form-customs__btn-add {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  border-radius: 8px;
  width: 100%;
  height: 40px;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: 0;

  color: #333333;
  border: 1px solid #333333;
  outline: none;
  cursor: pointer;
  background-color: transparent;
  svg {
    margin-right: 8px;
  }
}

.calc-customs-item__col-small_price-right {
  width: 240px;
}
.calc-customs-item__row-small {
  display: flex;
  margin-right: -10px;
  margin-left: -10px;
  flex-grow: 1;
  @media (max-width: 767px) {
    flex-direction: column;
  }
}
.calc-customs-item__col-small {
  padding-left: 10px;
  padding-right: 10px;

  &:first-of-type {
    flex-grow: 1;
  }
}
</style>
